module.exports = __webpack_public_path__ + "static/img/automation_level3.8018fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation_level3.png
// module id = Aaib
// module chunks = 62